"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagesService = void 0;
class ImagesService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Profile Img
     * Empty function, but we need to export the constants
     * @param img
     * @returns any Successful Response
     * @throws ApiError
     */
    chathostProfileImg(img) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/chathost/images/',
            query: {
                'img': img,
            },
            errors: {
                401: `Unauthorized`,
                422: `Validation Error`,
            },
        });
    }
}
exports.ImagesService = ImagesService;
